
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/postavschikam-partneram",
      function () {
        return require("private-next-pages/postavschikam-partneram.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/postavschikam-partneram"])
      });
    }
  